module.exports = __webpack_public_path__ + "media/smiles/neutral_1-8b717272.svg";